import { render } from "./Insight.vue?vue&type=template&id=f4dc4a9e&scoped=true&lang=html"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"

import "./Insight.vue?vue&type=style&index=0&id=f4dc4a9e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4dc4a9e"]])

export default __exports__